import SuperJSON from "superjson";
import Id from "../types/Id";

export default class SubmissionId extends Id<"submission"> {}

SuperJSON.registerClass(SubmissionId, { identifier: "SubmissionId" });
